export const getErrorMessage = (validationStore, name) => validationStore.customVuelidate.v$[name]?.$errors[0]?.$message
